import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { CompanyUserService } from '@treasury/domain/company/user';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-wizard';
import { TmToastService } from '@treasury/presentation/services/toast';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../../limits-and-entitlements/limits-and-entitlements.component';
import './partials/wires-domestic.component';
import './partials/wires-international.component';

@customElement('tm-bo-limits-and-entitlements-wire')
export class Wire extends TmBaseComponent {
    @InjectProperty()
    declare private readonly companyUserService: CompanyUserService;

    @InjectProperty()
    declare private readonly toastService: TmToastService;

    @property()
    declare private readonly companyId: number;

    @property()
    declare private readonly userId: number;

    @state()
    private activeTabIndex = 0;

    public render() {
        return html` <tm-wizard
            .activeTabIndex=${this.activeTabIndex}
            .wizardMode=${false}
            @tab-change=${(e: CustomEvent) => (this.activeTabIndex = e.detail.index)}
        >
            <tm-bo-wires-domestic-permissions
                .companyId=${this.companyId}
                .userId=${this.userId}
            ></tm-bo-wires-domestic-permissions>
            <tm-bo-wires-international-permissions
                .companyId=${this.companyId}
                .userId=${this.userId}
            ></tm-bo-wires-international-permissions>
        </tm-wizard>`;
    }
}
